// Defers non-critical work (third-party SDK init) until the browser is idle,
// keeping it off the critical path of the initial load. Safari has no
// requestIdleCallback, so fall back to a short timeout.
export function scheduleIdle(callback: () => void) {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(callback);
    return;
  }
  setTimeout(callback, 1);
}
